// import './polyfills.ts';

import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { enableProdMode } from '@angular/core';
import { environment } from './environments/environment';
import { AppModule } from './app/app.module';
import { angularPlugin } from '@datadog/browser-rum-angular';
import { datadogRum } from '@datadog/browser-rum';
import { datadogLogs } from '@datadog/browser-logs';

if (environment.production) {
  console.log("ATAM Dev2 is running in production mode ->", environment.production);
  enableProdMode();
}

if (environment.appConfig.rum) {
  try {
    datadogLogs.init({
      clientToken: environment.appConfig.rum.clientToken,
      site: environment.appConfig.rum.site,
      forwardErrorsToLogs: environment.appConfig.rum.forwardErrorsToLogs,
    });

    datadogRum.init({
      applicationId: environment.appConfig.rum.applicationId,
      clientToken: environment.appConfig.rum.clientToken,
      site: environment.appConfig.rum.site,
      service: environment.appConfig.rum.service,
      sessionSampleRate: environment.appConfig.rum.sessionSampleRate,
      sessionReplaySampleRate: environment.appConfig.rum.sessionReplaySampleRate,
      defaultPrivacyLevel: environment.appConfig.rum.defaultPrivacyLevel,
      env: environment.appConfig.rum.environment,
      version: environment.appConfig.rum.version,
      trackResources: environment.appConfig.rum.trackResources,
      trackUserInteractions: environment.appConfig.rum.trackUserInteractions,
      trackLongTasks: environment.appConfig.rum.trackLongTasks,
      plugins: [angularPlugin({ router: true })],
    });
  } catch (err) {
    // Datadog init failures must never block app bootstrap
    console.error('Failed to initialize Datadog RUM/logs', err);
  }
}

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));
